import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Button, Typography, Paper, Grid } from '@mui/material';
import Header from '../../components/Header';
import ClaimForm from '../../../src/files/Claim form.pdf';
import CheckList from '../../../src/files/Check List.doc';
import { useLocation } from 'react-router-dom';
import SelfPolicy from './SelfPolicy';
import FolaterPolicy from './FolaterPolicy';
import { Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";


import './contacts.css';

const Contacts = () => {
  const [insurance, setInsurance] = useState("XYZ Ltd");
  const [TPA, setTPA] = useState("");
  const [SI, setSI] = useState("500000");
  const [period, setPeriod] = useState("1st Apr 2024 To 31st March 2025");
  const [accountData, setAccountData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [account, setAccountId] = useState(null);
  const [mobileNumber, setMobileNumber] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [nullFields, setNullFields] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(sessionStorage.getItem('selectedAccount'));
  const location = useLocation();

  const primaryColor = '#0a88ef';
  const secondaryColor = '#FFC107';
  const darkColor = '#333';
  const lightColor = '#FFF';
  const borderColor = '#E0E0E0';

  useEffect(() => {
    const fetchNullFields = async () => {
      try {
        const response = await fetch(`https://api.cri.co.in/api/check-null-fields/${selectedAccount}`);
        const data = await response.json();

        if (response.ok) {
          setNullFields(data.nullFields);
        } else {
          console.error('Error fetching null fields:', data.error);
        }
      } catch (error) {
        console.error('Error fetching null fields:', error);
      }
    };
    fetchNullFields();
  }, [selectedAccount]);


  const [anchorEl, setAnchorEl] = useState(null);
const openMenu = Boolean(anchorEl);

const handleMenuClick = (event) => {
  setAnchorEl(event.currentTarget);
};

const handleMenuClose = () => {
  setAnchorEl(null);
};

const handleDownload = (type) => {
  window.open(`https://api.cri.co.in/api/files/download/${accountId}/${type}`, '_blank');
  handleMenuClose();
};


  useEffect(() => {
    const storedAccountId = sessionStorage.getItem('selectedAccount');
    const storedMobileNumber = sessionStorage.getItem('mobileNumber');

    setAccountId(storedAccountId);
    setMobileNumber(storedMobileNumber);

    if (storedAccountId && storedMobileNumber) {
      fetchLiveData(storedAccountId, storedMobileNumber);
    }
  }, [account, mobileNumber, selectedAccount]);

  const fetchLiveData = async (accountId, mobileNumber) => {
    console.log('Fetching data with Account ID:', accountId);
    console.log('Fetching data with Mobile Number:', mobileNumber);
    try {
      const response = await fetch(`https://api.cri.co.in/api/account/${accountId}/live-data-by-mobile/${mobileNumber}`);

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error:', errorData.error);
        return;
      }

      const data = await response.json();
      console.log('Live Data:', data);

      setRowData(data);
    } catch (error) {
      console.error('Error fetching live data:', error);
    }
  };

  const query = new URLSearchParams(location.search);
  const accountId = query.get('accountId');

  useEffect(() => {
    const fetchAccountData = async () => {
      const query = new URLSearchParams(location.search);
      const accountId = query.get('accountId');

      if (accountId) {
        try {
          const res = await axios.get(`https://api.cri.co.in/api/accounts/${accountId}`);
          setAccountData(res.data);
          sessionStorage.setItem('mobileNumber', res.data.hrNumber);
          console.log(res.data);
        } catch (err) {
          setError('Failed to fetch account data');
          console.error('Error fetching account data:', err);
        } finally {
          setLoading(false);
        }
      } else {
        setError('No account ID provided');
        setLoading(false);
      }
    };

    fetchAccountData();
    
  }, [location.search, selectedAccount]);

  const getRowDataByRelation = (relation) => {
    const foundRow = rowData.find(item => {
      const relationValue = item.benef_relation || ''; // Fallback to an empty string if it's null or undefined
      return (
        relationValue.toLowerCase() === relation.toLowerCase() || // Check for lowercase match
        relationValue === 'Self' || // Check for "Self"
        relationValue === 'SELF'  || relationValue === 'EMPLOYEE' || relationValue==='EMP' || relationValue === 'Employee'// Check for "SELF"
      );
    });
    return foundRow || {}; // Return an empty object if no match is found
  };
  

  const selfData = getRowDataByRelation('Self');

  useEffect(() => {
    if (!nullFields.includes('policyCoverageSelfFile')) {
      setSelectedPolicy('self');
    } else if (!nullFields.includes('policyCoverageFloaterFile')) {
      setSelectedPolicy('floater');
    }
  }, [nullFields]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;


  const openBlackListHospital = () => {
  const value = accountData?.blacklist; // your DB field

  // CASE 1: If value is a LINK → open link
  if (value && value.startsWith("http")) {
    window.open(value, "_blank");
    return;
  }

  // CASE 2: Otherwise treat it as FILE → download
  if (accountId) {
    window.open(
      `https://api.cri.co.in/api/files/download/${accountId}/blacklist`,
      "_blank"
    );
    return;
  }

  // CASE 3: Nothing available
  alert("No link or file found for BlackList Hospital.");
};



  return (
    <Box m="20px" sx={{ textAlign: 'center'}}>
      <Header title={`Policy Coverage : ${accountData?.accountName || ''}`} />

      <Box
  sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    mb: 3,
  }}
>
  {/* First Section */}
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      gap: 2,
      justifyContent: 'space-between',
      alignItems: 'center',
      p: 2,
      border: `1px solid ${borderColor}`,
      borderRadius: 2,
      backgroundColor: '#F5F5F5',
    }}
  >
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '18px',color:'#393184' }}>
        Insurance :
      </Typography>
      <Typography variant="body1" sx={{ fontSize: '18px',fontWeight:700 }}>
        {selfData.ro_name}
      </Typography>
    </div>

    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '18px',color:'#393184' }}>
        TPA :
      </Typography>
      <Typography variant="body1" sx={{ fontSize: '18px',fontWeight:700 }}>
        {selfData.TPA}
      </Typography>
    </div>
  </Box>

  {/* Second Section */}
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      gap: 2,
      justifyContent: 'space-between',
      alignItems: 'center',
      p: 2,
      border: `1px solid ${borderColor}`,
      borderRadius: 2,
      backgroundColor: '#F5F5F5',
    }}
  >
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '18px',color:'#393184' }}>
        SI :
      </Typography>
      <Typography variant="body1" sx={{ fontSize: '18px',fontWeight:700 }}>
        {selfData.benef_sum_insured}
      </Typography>
    </div>

    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '18px',color:'#393184' }}>
        Period :
      </Typography>
      <Typography variant="body1" sx={{ fontSize: '18px',fontWeight:700 }}>
        {selfData.polstartdate} / {selfData.polenddate}
      </Typography>
    </div>
  </Box>
</Box>


      <Box className="userbutton" mb={3}>
        <Grid container spacing={2} justifyContent="center">
          
  <Grid item xs={12} sm={6} md={3}>
    <Button
      fullWidth
      variant="contained"
      style={{ backgroundColor: '#17a2b8', color: '#FFF', fontSize: '15px' }}
      onClick={() =>
        window.open(
          `https://api.cri.co.in/api/files/download/${accountId}/opdclaim`,
          '_blank'
        )
      }
    >
      OPD Claim Form
    </Button>
  </Grid>


          <Grid item xs={12} sm={6} md={3}>
            <Button
              fullWidth
              variant="contained"
              style={{ backgroundColor: primaryColor, fontSize: '15px' }}
              href={accountData?.networkHospitalLink}
              target="_blank"
            >
              Network Hospital
            </Button>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
  <Button
    fullWidth
    variant="contained"
    style={{ backgroundColor: '#343a40', color: '#FFF', fontSize: '15px' }}
    onClick={openBlackListHospital}
  >
    BlackList Hospital
  </Button>
</Grid>


          
  <>
    <Grid item xs={12} sm={6} md={3}>
      <Button
        fullWidth
        variant="contained"
        style={{
          backgroundColor: '#17a2b8',
          fontSize: '15px',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '6px',
        }}
        onClick={handleMenuClick}
        endIcon={openMenu ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      >
        IPD Claim Form
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        PaperProps={{
          style: { width: 200, borderRadius: 8 },
        }}
      >
        <MenuItem onClick={() => handleDownload('claimformA')}>Claim Form A</MenuItem>
        <MenuItem onClick={() => handleDownload('claimformB')}>Claim Form B</MenuItem>
      </Menu>
    </Grid>
  </>



          {/* <Grid item xs={12} sm={6} md={3}>
            <Button
              fullWidth
              variant="contained"
              style={{ backgroundColor: secondaryColor, fontSize: '15px' }}
              href={ClaimForm}
              target="_blank"
              onClick={() => window.open(`https://api.cri.co.in/api/files/download/${accountId}/cashLess`, '_blank')}
            >
              CashLess
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Button
              fullWidth
              variant="contained"
              style={{ backgroundColor: secondaryColor, fontSize: '15px' }}
              href={ClaimForm}
              target="_blank"
              onClick={() => window.open(`https://api.cri.co.in/api/files/download/${accountId}/reimbursement`, '_blank')}
            >
              Reimbursement
            </Button>
          </Grid> */}
          <Grid item xs={12} sm={6} md={3}>
            <Button
              fullWidth
              variant="contained"
              style={{ backgroundColor: '#343a40', color: '#FFF', fontSize: '15px' }}
              onClick={() => window.open(`https://api.cri.co.in/api/files/download/${accountId}/exclusionListFile`, '_blank')}
            >
              Exclusion List
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Button
              fullWidth
              variant="contained"
              style={{ backgroundColor: '#28a745', color: '#FFF', fontSize: '15px' }}
              target="_blank"
              onClick={() => window.open(`https://api.cri.co.in/api/files/download/${accountId}/checkListFile`, '_blank')}
            >
              Check List
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* Render selected policy based on available files */}
      {selectedPolicy === 'self' && <SelfPolicy />}
      {selectedPolicy === 'floater' && <FolaterPolicy />}
    </Box>
  );
};

export default Contacts;
